<template>
    <div>
      <div v-if="isDetail">
        <Detail ref="Detail" @back="isDetail = false"></Detail>
      </div>
      <page-header-wrapper v-else>
        <a-card :bordered="false">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="派单编号">
                    <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <!-- <a-col :md="6" :sm="24" v-if="(userType == 0 || userType == 1) && !regionId">
                  <a-form-item label="区域">
                    <a-select
                      show-search
                      :allowClear="true"
                      v-model="queryParam.regionId"
                      placeholder="请选择"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option v-for="d in listRegion" :key="d.id">{{ d.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                <a-col :md="6" :sm="24">
                  <a-form-item label="业主姓名">
                    <a-input @keyup.enter="handleQuery" v-model="queryParam.ownerName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="业主电话">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.ownerPhone"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="验收员姓名">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.pressureTestName"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced">
                  <a-form-item label="验收员电话">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.pressureTestUserPhone"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced">
                  <a-form-item label="经销商">
                    <!-- <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.pressureTestUserPhone"
                    placeholder="请输入"
                    allow-clear
                  /> -->
                    <a-select
                      show-search
                      :allowClear="true"
                      v-model="queryParam.tenantAgentId"
                      placeholder="请选择"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option v-for="d in agentList" :key="d.id">{{ d.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced">
                  <a-form-item label="预约姓名">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.reservationName"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced">
                  <a-form-item label="预约手机号">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.reservationPhone"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced && (status == 5 || status == 7)">
                  <a-form-item label="水工姓名">
                    <a-input @keyup.enter="handleQuery" v-model="queryParam.waterName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced && (status == 5 || status == 7)">
                  <a-form-item label="水工电话">
                    <a-input
                      @keyup.enter="handleQuery"
                      v-model="queryParam.waterPhone"
                      placeholder="请输入"
                      allow-clear
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced && !isOperate">
                  <a-form-item label="订单状态">
                    <a-select
                      show-search
                      :allowClear="true"
                      v-model="queryParam.statusVlaue"
                      placeholder="请选择"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      @change="handleValue"
                    >
                      <a-select-option :value="3">待接单</a-select-option>
                      <a-select-option :value="1">待派单</a-select-option>
                      <a-select-option :value="4">待试压</a-select-option>
                      <a-select-option :value="5">待审核</a-select-option>
                      <a-select-option :value="20">已驳回</a-select-option>
                      <a-select-option :value="7">已完成</a-select-option>
                      <a-select-option :value="2">已拒绝</a-select-option>
                      <a-select-option :value="8">已作废</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="advanced">
                  <a-form-item label="订单类型">
                    <a-select
                      show-search
                      :allowClear="true"
                      v-model="queryParam.orderType"
                      placeholder="请选择"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option :value="0">普通服务单</a-select-option>
                      <a-select-option :value="1">预约服务单</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <template v-if="advanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="小区名称">
                      <a-input v-model="queryParam.minAreaName" placeholder="请输入" allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <template v-if="advanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="详细地址">
                      <a-input v-model="queryParam.ownerAddress" placeholder="请输入" allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <!-- <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="项目经理">
                    <a-input v-model="queryParam.proBane" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="项目经理电话">
                    <a-input v-model="queryParam.proPhone" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template> -->
                <template v-if="advanced">
                  <a-col :md="12" :sm="24">
                    <a-form-item label="省市区">
                      <v-distpicker
                        :province="queryParam.province"
                        :city="queryParam.city"
                        :area="queryParam.area"
                        @province="onChangeProvince"
                        @city="onChangeCity"
                        @area="onChangeArea"
                      >
                      </v-distpicker>
                    </a-form-item>
                  </a-col>
                </template>
                <!-- <template v-if="advanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="市">
                      <a-input v-model="queryParam.city" placeholder="请输入" allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <template v-if="advanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="区">
                      <a-input v-model="queryParam.area" placeholder="请输入" allow-clear />
                    </a-form-item>
                  </a-col>
                </template> -->
                <template v-if="advanced">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="时间范围">
                      <a-range-picker
                        v-model="value"
                        format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']"
                        @change="onChange"
                      />
                      <!-- :show-time="{ format: 'HH:mm:ss' }" -->
                    </a-form-item>
                  </a-col>
                </template>
  
                <!-- <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="租户编码">
                    <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="租户编码">
                    <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="信用代码">
                    <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="联系人">
                    <a-input v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="电话">
                    <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="状态">
                    <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                      <a-select-option :value="0"> 正常 </a-select-option>
                      <a-select-option :value="1"> 异常关闭 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="租户类型">
                    <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                      <a-select-option :value="1"> 厂商 </a-select-option>
                      <a-select-option :value="2"> 经销商 </a-select-option>
                      <a-select-option :value="3"> 分经销商 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="营业状态">
                    <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                      <a-select-option :value="0"> 营业中 </a-select-option>
                      <a-select-option :value="10"> 维修升级中 </a-select-option>
                      <a-select-option :value="60"> 暂停营业 </a-select-option>
                      <a-select-option :value="70"> 隐藏 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
             
              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="时间范围">
                    <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onChange" />
                  </a-form-item>
                </a-col>
              </template> -->
                <a-col :md="(!advanced && 6) || 24" :sm="24">
                  <span
                    class="table-page-search-submitButtons"
                    :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                  >
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                    <a @click="toggleAdvanced" style="margin-left: 8px">
                      {{ advanced ? '收起' : '展开' }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <div class="table-operations">
  
            <table-setting
              :style="{ float: 'right' }"
              :table-size.sync="tableSize"
              v-model="columns"
              :refresh-loading="loading"
            ></table-setting>
          </div>
          <!-- 增加修改 -->
          <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
          <!-- 审核 -->
          <Examine ref="Examine" @ok="getList"></Examine>
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 1560, y: 960 }"
          >
            <span slot="status" slot-scope="text, record">
              <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
            </span>
            <span slot="tenantFirmName" slot-scope="text, record">
              <span v-if="record.tenantFirmId !== record.tenantAgentId">{{ record.tenantFirmName }}</span>
              <span v-else>--</span>
            </span>
            <span slot="tenantAgentName" slot-scope="text, record">
              <span v-if="record.tenantAgentId == record.tenantId">{{ record.tenantName }}</span>
              <span v-else></span>
            </span>
            <span slot="tenantName" slot-scope="text, record">
              <span v-if="record.tenantAgentId !== record.tenantId && record.tenantFirmId !== record.tenantId">{{
                record.tenantName
              }}</span>
              <span v-else></span>
            </span>
            <span slot="pressureResult" slot-scope="text, record">
              <span>合格</span>
            </span>
            <span slot="ownerEvaluate" slot-scope="text, record">
              <span>{{
                record.ownerEvaluate == 1
                  ? '非常满意'
                  : record.ownerEvaluate == 2
                  ? '满意'
                  : record.ownerEvaluate == 3
                  ? '不满意'
                  : ''
              }}</span>
            </span>
            <span slot="city" slot-scope="text, record"> {{ record.city }}{{ record.area }} </span>
            <span slot="subTime" slot-scope="text, record">
              {{ parseTime(record.subTime) }}
            </span>
            <span slot="status" slot-scope="text, record">
              <!-- {{ parseTime(record.createTime) }} -->
              <a-tag color="red" v-if="record.status"> 禁用 </a-tag>
              <a-tag color="green" v-else> 启用 </a-tag>
            </span>
            <span slot="operation" slot-scope="text, record">
              <!-- <a @click="$refs.Examine.init(record, 4)" v-hasPermi="['abm-fix:order:edit01']" v-if="record.status == 1">
                派单
              </a>
              <a-divider type="vertical" v-hasPermi="['abm-fix:order:edit']" v-if="record.status == 1" />
              <a
                @click="$refs.createForm.handleUpdate(record, undefined)"
                v-hasPermi="['abm-fix:order:edit']"
                v-if="record.status !== 8 && record.status !== 5"
              >
                修改
              </a>
              <a-divider
                type="vertical"
                v-hasPermi="['abm-fix:order:void']"
                v-if="record.status !== 8 && record.status !== 5"
              /> -->
              <a @click="handleDetail(record)"> 详情 </a>
              <a-divider
                type="vertical"
                v-hasPermi="['abm-fix:order:query']"
                v-if="
                  record.acceptStatus == 1 ||
                  record.acceptStatus == 3 ||
                  (record.status == 1 && record.tenantId === tenantId) ||
                  record.status == 7
                "
              />
              <a-dropdown
                v-hasPermi="['abm-fix:order:query']"
                v-if="
                  record.acceptStatus == 1 ||
                  record.acceptStatus == 3 ||
                  (record.status == 1 && record.tenantId === tenantId) ||
                  record.status == 7
                "
              >
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['abm-fix:order:edit03']" v-if="record.acceptStatus == 1">
                    <a @click="$refs.Examine.init(record, record.acceptStatus)"> 审核 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['abm-fix:order:edit03']" v-if="record.acceptStatus == 1">
                    <a @click="$refs.Examine.init(record, 3)"> 修改积分 </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['abm-fix:order:edit03']" v-if="record.status !== 8">
                    <a @click="handleDelete(record)"> 作废订单 </a>
                  </a-menu-item>
                  <!-- <a-menu-item v-hasPermi="['monitor:job:query']">
                    <a @click="$refs.Examine.init(record, 10)"> 配置Vr信息 </a>
                  </a-menu-item> -->
                  <a-menu-item v v-if="record.status == 7">
                    <a @click="handleLookDown(record)"> 下载验收报告 </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </a-card>
      </page-header-wrapper>
    </div>
  </template>
  
  <script>
  import { fetchRegin, delObj, statusObj, orderVoid, acceptanceReport, recordPage } from '@/api/pressure/dispatch'
  import { regionList } from '@/api/pressure/region'
  
  import Detail from './modules/detail'
  import Examine from './modules/examine'
  import { listTenant } from '@/api/system/tenant'
  import { tableMixin } from '@/store/table-mixin'
  import moment from 'moment'
  import { isDate } from 'lodash'
  export default {
    name: 'Post',
    components: {
      Detail,
      Examine,
    },
    mixins: [tableMixin],
    dicts: ['sys_enable_disable'],
    props: {
      isOperate: {
        type: Boolean,
        default: true,
      },
      firmId: {
        type: [String, Number],
      },
      tenantId: {
        type: [String, Number],
      },
      tenantFirmId: {
        type: [String, Number],
      },
      regionId: {
        type: [String, Number],
      },
    },
    data() {
      return {
        list: [],
        value: [],
        isDetail: false,
        selectedRowKeys: [],
        selectedRows: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
        loading: false,
        total: 0,
        queryParam: {
          pageNum: 1,
          pageSize: 10,
          postCode: undefined,
          postName: undefined,
          status: undefined,
          regionId: undefined,
          orderType: undefined,
        },
        columns: [
          {
            title: '派单编号',
            dataIndex: 'orderNo',
            align: 'center',
            fixed: 'left',
            width: 200,
          },
          {
            title: '所属企业品牌',
            dataIndex: 'tenantFirmName',
            align: 'center',
            width: 130,
            visible: false,
          },
          {
            title: '所属经销商',
            dataIndex: 'tenantAgentName',
            scopedSlots: { customRender: 'tenantAgentName' },
            align: 'center',
            width: 130,
            visible: false,
          },
          {
            title: '分销商',
            dataIndex: 'tenantName',
            scopedSlots: { customRender: 'tenantName' },
            align: 'center',
            width: 100,
            visible: false,
          },
          {
            title: '所属省',
            width: 100,
            dataIndex: 'province',
            ellipsis: true,
            align: 'center',
            visible: false,
          },
          {
            title: '所属市县',
            dataIndex: 'city',
            scopedSlots: { customRender: 'city' },
            ellipsis: true,
            width: 130,
            align: 'center',
          },
          {
            title: '业主姓名',
            dataIndex: 'ownerName',
            ellipsis: true,
            width: 100,
            align: 'center',
          },
          {
            title: '业主电话',
            dataIndex: 'ownerPhone',
            ellipsis: true,
            width: 110,
            align: 'center',
          },
          {
            title: '验收员名称',
            dataIndex: 'pressureTestName',
            width: 110,
            ellipsis: true,
            align: 'center',
          },
          {
            title: '验收员电话',
            dataIndex: 'pressureTestUserPhone',
            width: 110,
            ellipsis: true,
            align: 'center',
          },
          // {
          //   title: '派单人',
          //   dataIndex: 'proBane',
          //   ellipsis: true,
          //   align: 'center',
          // },
          // {
          //   title: '派单人手机号',
          //   dataIndex: 'proPhone',
          //   ellipsis: true,
          //   align: 'center',
          // },
          {
            title: '测压结果',
            dataIndex: 'pressureResult',
            scopedSlots: { customRender: 'pressureResult' },
            width: 80,
            ellipsis: true,
            align: 'center',
          },
          {
            title: '评价',
            dataIndex: 'ownerEvaluate',
            scopedSlots: { customRender: 'ownerEvaluate' },
            ellipsis: true,
            width: 90,
            align: 'center',
          },
          // {
          //   title: '设备编号',
          //   dataIndex: 'devCode',
          //   ellipsis: true,
          //   align: 'center',
          // },
          // {
          //   title: '租户简称',
          //   dataIndex: 'referredName',
          //   align: 'center',
          // },
          {
            title: '建单时间',
            dataIndex: 'createTime',
            ellipsis: true,
            width: 160,
            align: 'center',
          },
          {
            title: '预约时间',
            dataIndex: 'reservationTime',
            ellipsis: true,
            width: 180,
            align: 'center',
          },
          {
            title: '服务完成时间',
            dataIndex: 'subTime',
            ellipsis: true,
            width: 160,
            align: 'center',
          },
          {
            title: '操作',
            dataIndex: 'operation',
            width: 110,
            scopedSlots: { customRender: 'operation' },
            align: 'center',
            fixed: 'right',
          },
        ],
        orderType: 0,
        status: 1,
        agentList: [],
        listRegion: [],
      }
    },
    filters: {},
    created() {
      console.log(this.$route.name, '的点点滴滴')
      if (!this.isOperate) {
        this.columns.pop()
      }
      const name = this.$route.name
      if (name === 'WorkerOne') {
        // 预约订单
        this.queryParam.orderType = 1
        this.orderType = 1
      } else if (name === 'WorkerTwo') {
        // 待确认
        this.queryParam.status = 0
        this.status = 0
      } else if (name === 'WorkerThree') {
        // 待派单
        this.queryParam.status = 1
        this.status = 1
        this.columns.splice(-2, 1)
        this.columns.splice(-4, 1)
        this.columns.splice(-4, 1)
      } else if (name === 'WorkerFour') {
        // 派单拒绝
        this.queryParam.status = 2
        this.status = 2
        this.columns.splice(-2, 1)
        this.columns.splice(-4, 1)
        this.columns.splice(-4, 1)
      } else if (name === 'WorkerFive') {
        // 待接单
        this.queryParam.status = 3
        this.status = 3
        this.columns.splice(-2, 1)
        this.columns.splice(-4, 1)
        this.columns.splice(-4, 1)
      } else if (name === 'WorkerSix') {
        // 已受理
        this.queryParam.status = 4
        this.status = 4
        this.columns.splice(-2, 1)
        this.columns.splice(-4, 1)
        this.columns.splice(-4, 1)
      } else if (name === 'WorkerSeven') {
        // 已提交审核
        this.queryParam.status = 5
        this.queryParam.acceptStatus = 1
        this.status = 5
      } else if (name === 'WorkerEight') {
        // 已完成
        this.queryParam.status = 7
        this.status = 7
      } else if (name === 'WorkerTen') {
        // 打回
        this.queryParam.acceptStatus = 2
        // this.status = 7
      } else if (name === 'WorkerNine') {
        // 订单作废
        this.queryParam.status = 8
        this.status = 8
      }
      this.queryParam.tenantId = this.tenantId
      this.queryParam.tenantFirmId = this.tenantFirmId
      this.queryParam.regionId = this.regionId
      // if (this.tenantId || this.regionId || this.tenantFirmId) {
      //   this.queryParam.status = 7
      // }
      this.getList()
  
      this.getAgent()
      console.log(this.userType, 'this.userTypethis.userType')
  
    //   if (this.userType == 0 || this.userType == 1) {
    //     this.getQu()
    //   }
      if (this.userType === 1) {
        this.columns.splice(1, 1)
      } else if (this.userType == 2) {
        this.columns.splice(2, 1)
      }
    },
    computed: {
      userType() {
        return this.$store.state.user.userTentant.type
      },
    },
    // watch: {
    //   tenantFirmId: {
    //     handler(newVal, oldVal) {
    //       console.log('User data changed:', newVal)
    //       this.getList()
    //     },
    //     deep: true,
    //   },
    // },
    methods: {
      // 点击跳转详情
      handleDetail(e) {
        this.isDetail = true
        this.$nextTick(() => {
          this.$refs.Detail.init(e, 1)
        })
      },
      //  状态变化
      handleValue(e) {
        console.log(e, '的点点滴滴测试')
        if (e == 20) {
          this.queryParam.acceptStatus = 2
          this.queryParam.status = ''
        } else {
          this.queryParam.status = e
          if (e == 5) {
            this.queryParam.acceptStatus = 1
          } else {
            this.queryParam.acceptStatus = ''
          }
        }
      },
      // 点击确定
      onChange(e) {
        console.log(e, '的点点滴滴')
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      // 选择省
      onChangeProvince(e) {
        this.queryParam.province = e.value
      },
      // 选择市
      onChangeCity(e) {
        this.queryParam.city = e.value
      },
      // 选择区
      onChangeArea(e) {
        this.queryParam.area = e.value
      },
      // 查代理商
      getAgent() {
        // listTenant({ pageNum: 1, pageSize: 9999, type: 1 }).then((res) => {
        //   this.agentList = res.data.records
        //   console.log(this.agentList, '的点点滴滴this.agentListthis.agentList')
        // })
      },
      // 查区域
      getQu() {
        regionList({ pageNum: 1, pageSize: 9999, type: 1 }).then((res) => {
          this.listRegion = res.data
        })
      },
      /** 查询部门列表 */
      getList() {
        this.loading = true
        fetchRegin(this.queryParam).then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        })
      },
      // 下载验收报告
      handleLookDown(e) {
        acceptanceReport({ id: e.id }).then((res) => {
          // console.log(res,'resresres');
          // this.$message.success('下载成功')
          window.open(this.$url + res.data)
        })
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.queryParam = {
          pageNum: 1,
          pageSize: 10,
          postCode: undefined,
          postName: undefined,
          status: undefined,
          regionId: undefined,
          orderType: undefined,
        }
        if (this.orderType) {
          this.queryParam.orderType = this.orderType
        } else {
        }
  
        if (this.status) {
          this.queryParam.status = this.status
        }
        if (this.tenantId) {
          this.queryParam.tenantId = this.tenantId
          // this.queryParam.status = 7
        }
        if (this.regionId) {
          this.queryParam.regionId = this.regionId
          // this.queryParam.status = 7
        }
        if (this.tenantFirmId) {
          this.queryParam.tenantFirmId = this.tenantFirmId
          // this.queryParam.status = 7
        }
        this.handleQuery()
      },
      onShowSizeChange(current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize(current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map((item) => item.id)
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      // 禁用启用
      handleDeletes(row) {
        var that = this
        // let ids = []
        // if (row.id) {
        //   ids = [row.id]
        // } else {
        //   ids = this.ids
        // }
        const text = '是否要作废此订单?'
        this.$confirm({
          title: text,
          onOk() {
            return statusObj({ id: row.id }).then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('操作成功', 3)
            })
          },
          onCancel() {},
        })
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        var that = this
        let ids = []
        if (row.id) {
          ids = [row.id]
        } else {
          ids = this.ids
        }
        this.$confirm({
          title: '是否要作废此订单?',
          onOk() {
            return orderVoid({ id: row.id }).then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('操作成功', 3)
            })
          },
          onCancel() {},
        })
      },
      /** 导出按钮操作 */
      handleExport() {
        var that = this
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据而非选中数据',
          onOk() {
            that.download(
              'fix/order/export',
              {
                ...that.queryParam,
              },
              `post_${new Date().getTime()}.xlsx`
            )
          },
          onCancel() {},
        })
      },
    },
  }
  </script>
  